<div>
  <span>NCD APP </span>
  <i class="material-icons pull-right fs18" style="color: darkgray;" (click)="snackBarRef.dismiss()">close</i>
  <span
    class="pull-right"
    style="color: #fff; letter-spacing: 1px; padding-right: 10px; font-size: 16px;"
    (click)="addToHomeScreen()"
    >ADD TO HOME SCREEN</span
  >
</div>
